<template>
  <gl-modal
    capitalize-title
    class="redirect-to-last-route-modal"
    closable
    closable-top
    full-buttons
    :loading="loading"
    submit-title="Yes"
    title="Continue?"
    :value="getShowRedirectToLastRouteModal"
    width="480"
    v-on="$listeners"
    @close="onClose"
    @submit="confirm"
  >
    <template #mainSlot>
      <div class="proceed-modal-message-wrapper break-word">
        Continue from the previous point?
      </div>
    </template>
  </gl-modal>
</template>

<script>
// Vuex
import { mapMutations, mapGetters } from 'vuex'

// Components
import GlModal from '@/components/gl-modal'

export default {
  components: {
    GlModal,
  },
  inheritAttrs: false,
  props: {
    message: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('payment', ['getShowRedirectToLastRouteModal']),
  },
  methods: {
    ...mapMutations('payment', ['SET_REDIRECT_TO_LAST_ROUTE_MODAL']),
    confirm() {
      this.SET_REDIRECT_TO_LAST_ROUTE_MODAL(false)
      const comeBackPath = localStorage.getItem('comeBackPath')
      if (!comeBackPath) return
      this.$router.push(comeBackPath)
      localStorage.removeItem('comeBackPath')
    },
    onClose() {
      this.SET_REDIRECT_TO_LAST_ROUTE_MODAL(false)
      localStorage.removeItem('comeBackPath')
    },
  },
}
</script>

<style>
.proceed-modal-message-wrapper {
  padding: 24px 13px 24px 24px;
  font-weight: 500;
}
.redirect-to-last-route-modal .gl-form__actions .gl-button {
  flex: 1;
}
</style>
